"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getLayerFrom = exports.getLayerColor = exports.LAYER_COLORS = exports.transformerLayer = void 0;
var transformerLayer = {
  displayName: 'Transformers',
  name: 'transformers',
  color: '#000'
};
exports.transformerLayer = transformerLayer;
var LAYER_COLORS = {
  transformers: '#000',
  C01: '#330033',
  C02: '#330033',
  C03: '#330033',
  C04: '#330033',
  C05: '#660066',
  C06: '#660066',
  C07: '#660066',
  C08: '#660066',
  C09: '#990099',
  C10: '#990099',
  C11: '#990099',
  C12: '#990099',
  C13: '#CC00CC',
  C14: '#CC00CC',
  C15: '#CC00CC',
  C16: '#CC00CC',
  C17: '#FF00FF',
  C18: '#FF00FF',
  C19: '#FF00FF',
  C20: '#FF00FF',
  N01: '#003300',
  N02: '#003300',
  N03: '#003300',
  N04: '#003300',
  N05: '#003300',
  N06: '#006600',
  N07: '#006600',
  N08: '#006600',
  N09: '#006600',
  N10: '#006600',
  N11: '#009900',
  N12: '#009900',
  N13: '#009900',
  N14: '#009900',
  N15: '#009900',
  N16: '#00CC00',
  N17: '#00CC00',
  N18: '#00CC00',
  N19: '#00CC00',
  N20: '#00CC00',
  N21: '#00FF00',
  N22: '#00FF00',
  N23: '#00FF00',
  N24: '#00FF00',
  N25: '#00FF00',
  N26: '#33FF33',
  N27: '#33FF33',
  N28: '#33FF33',
  N29: '#33FF33',
  N30: '#33FF33',
  N31: '#66FF66',
  N32: '#66FF66',
  N33: '#66FF66',
  N34: '#66FF66',
  N35: '#66FF66',
  N36: '#99FF99',
  N37: '#99FF99',
  N38: '#99FF99',
  N39: '#99FF99',
  N40: '#99FF99',
  N41: '#CCFFCC',
  N42: '#CCFFCC',
  N43: '#CCFFCC',
  N44: '#CCFFCC',
  N45: '#CCFFCC',
  N46: '#CCFFCC',
  N47: '#CCFFCC',
  W01: '#000033',
  W02: '#000033',
  W03: '#000033',
  W04: '#000033',
  W05: '#000033',
  W06: '#000066',
  W07: '#000066',
  W08: '#000066',
  W09: '#000066',
  W10: '#000066',
  W11: '#000099',
  W12: '#000099',
  W13: '#000099',
  W14: '#000099',
  W15: '#000099',
  W16: '#0000CC',
  W17: '#0000CC',
  W18: '#0000CC',
  W19: '#0000CC',
  W20: '#0000CC',
  W21: '#0000FF',
  W22: '#0000FF',
  W23: '#0000FF',
  W24: '#0000FF',
  W25: '#0000FF',
  W26: '#0000FF',
  S01: '#003333',
  S02: '#003333',
  S03: '#003333',
  S04: '#003333',
  S05: '#003333',
  S06: '#006666',
  S07: '#006666',
  S08: '#006666',
  S09: '#006666',
  S10: '#006666',
  S11: '#009999',
  S12: '#009999',
  S13: '#009999',
  S14: '#009999',
  S15: '#009999',
  S16: '#00CCCC',
  S17: '#00CCCC',
  S18: '#00CCCC',
  S19: '#00CCCC',
  S20: '#00CCCC',
  S21: '#00FFFF',
  S22: '#00FFFF',
  S23: '#00FFFF',
  S24: '#00FFFF',
  S25: '#00FFFF',
  S26: '#33FFFF',
  S27: '#33FFFF',
  S28: '#33FFFF',
  S29: '#33FFFF',
  S30: '#33FFFF',
  S31: '#66FFFF',
  S32: '#66FFFF',
  S33: '#66FFFF'
};
exports.LAYER_COLORS = LAYER_COLORS;

var getLayerColor = function getLayerColor(layerName) {
  return (// @ts-ignore
    LAYER_COLORS[layerName] || '#000000'
  );
};

exports.getLayerColor = getLayerColor;

var getLayerFrom = function getLayerFrom(layerName, layerArray) {
  var layer = layerArray.find(function (e) {
    return e.op_name === layerName;
  });

  if (layer === undefined) {
    return undefined;
  }

  return {
    color: getLayerColor(layerName),
    name: layer.op_name,
    displayName: layer.name
  };
};

exports.getLayerFrom = getLayerFrom;
var _default = getLayerFrom;
exports.default = _default;